<template>
  <div class="pb-5 md:pb-10 pb-10 container max-w-5xl mx-auto">
    <h3 class="text-center text-2xl lg:text-3xl font-bold mx-6">Review and complete your details</h3>
    <ol class="flex-col sm:flex-row flex mt-4 ml-8 lg:ml-0 justify-center">
      <li class="table lg:w-auto text-xl md:text-lg pl-0 sm:px-6 mb-6 sm:mb-0 leading-loose md:leading-tight lg:leading-loose">
        <RoundTickIcon alt="Tick Icon" :class="{ 'text-polgrey-medium': !aboutYou, 'text-polgreen': aboutYou }" class="lg:mr-2 mr-4 icon h-10 w-10" />
        About you
      </li>
      <li class="lg:w-auto text-xl md:text-lg pl-0 sm:px-6 mb-6 sm:mb-0 leading-loose md:leading-tight lg:leading-loose">
        <RoundTickIcon alt="Tick Icon" :class="{ 'text-polgrey-medium': !whereYouLive, 'text-polgreen': whereYouLive }" class="lg:mr-2 mr-4 icon h-10 w-10" />
        Where you live
      </li>
      <li class="lg:w-auto text-xl md:text-lg pl-0 sm:px-6 mb-6 sm:mb-0 leading-loose md:leading-tight lg:leading-loose">
        <RoundTickIcon alt="Tick Icon" :class="{ 'text-polgrey-medium': !workAndFinances, 'text-polgreen': workAndFinances }" class="lg:mr-2 mr-4 icon h-10 w-10" />
        Work and finances
      </li>
      <li class="lg:w-auto text-xl md:text-lg pl-0 sm:px-6 mb-6 sm:mb-0 leading-loose md:leading-tight lg:leading-loose">
        <RoundTickIcon alt="Tick Icon" :class="{ 'text-polgrey-medium': !keepInTouch, 'text-polgreen': keepInTouch }" class="lg:mr-2 mr-4 icon h-10 w-10" />
        Keep in touch
      </li>
    </ol>
  </div>
</template>

<script>

import RoundTickIcon from '@/v2/assets/images/icons/round-tick.svg'

export default {
  name: 'ProgressTracker',
  components: {
    RoundTickIcon
  },
  props: {
    aboutYou: Boolean,
    whereYouLive: Boolean,
    workAndFinances: Boolean,
    keepInTouch: Boolean,
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .icon {
    @apply fill-current inline-block float-left;
  }

  .list-counter {
    padding: 0;
    list-style-type: none;
  }

  .list-counter li {
    counter-increment: step-counter;
    display: inline;
  }

  .list-counter li::before {
    content: counter(step-counter);
    margin-right: 5px;
    font-size: 80%;
    background-color: #ffffff;
    color: #000000;
    border: 1px solid #000000;
    padding: 3px 8px;
    border-radius: 100%;
  }

</style>
